// VNA-50 — Qué empleados de una tarjeta NO van a llegar al backend tal como están.
//
// Las dos pantallas de Nómina arman el payload filtrando filas: la de llenado descarta las
// que no tienen tarea (`buildEntries`), la de revisión además las que no tienen horas. Eso
// es correcto para una fila vacía de más, pero si el empleado entero queda sin filas —o
// tiene horas en una fila sin tarea— desaparecía sin aviso: "✓ Guardado", y al refrescar ya
// no estaba. Es lo que se reportó como "en el 120 no me deja añadir".
//
// Cada pantalla dice qué fila se guarda (su regla de filtrado); esto decide a quién avisar.

/**
 * @param {{ nombre: string, filas: { seGuarda: boolean, horas: number }[] }[]} empleados
 * @returns {string[]} nombres de los empleados que se perderían o perderían horas
 */
export function empleadosQueSeDescartan(empleados) {
  return empleados
    .filter(e =>
      !e.filas.some(f => f.seGuarda)
      || e.filas.some(f => !f.seGuarda && f.horas > 0)
    )
    .map(e => e.nombre);
}

export function avisoDescartados(nombres) {
  return `Falta la tarea o las horas de: ${nombres.join(', ')}\n\n`
    + 'Se requiere elegir la tarea y cargar las horas para guardar.';
}
